import { Chip, Stack, styled } from "@mui/material";

import { useState } from "react";
import useAuth from "../../context/UserContext";
import { downloadSummaryEnabled } from "../Permissions";
import { ChartByProject } from "./ChartByProject";
import { ChartByPurpose } from "./ChartByPurpose";

const PanelContainer = styled("div")(({ theme }) => ({
  width: "100%",
  padding: "32px 40px 48px 40px",
  borderWidth: "1px",
  borderRadius: "8px",
  backgroundColor: theme.palette.surfaceLight10.main,
  boxShadow: theme.mixins.shadowSurfaceLight10,
  ...theme.applyStyles("dark", {
    boxShadow: theme.mixins.shadowSurfaceDark10,
  }),
  marginTop: "16px",
}));

const DownloadsCharts = () => {
  const { user } = useAuth();
  const [chartToShow, setChartToShow] = useState<"purpose" | "project">("purpose");
  const isDownloadSummaryEnabled = downloadSummaryEnabled(user);
  const [useTextures, setUseTextures] = useState<boolean>(false);
  return (
    <PanelContainer>
      {isDownloadSummaryEnabled ? (
        <Chip variant="success" label="CS & Customer" />
      ) : (
        <Chip variant="info" label="CS Only" />
      )}
      <Stack sx={{ mt: 2 }}>
        {chartToShow === "purpose" ? (
          <ChartByPurpose
            handleOnChange={() => {
              setChartToShow("project");
            }}
            useTextures={useTextures}
            setUseTextures={setUseTextures}
          />
        ) : (
          <ChartByProject
            handleOnChange={() => setChartToShow("purpose")}
            useTextures={useTextures}
            setUseTextures={setUseTextures}
          />
        )}
      </Stack>
    </PanelContainer>
  );
};

export { DownloadsCharts };
